import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import styled from '@emotion/styled';

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  width: 80,
  height: 80,
}));

const ProgressContainer = styled('div')(({ theme }) => ({
  position: 'relative',
}));

const TextContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const ProgressText = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.primary.main,
}));

const Label = styled(Typography)(({ theme }) => ({
  fontSize: 11,
  color: theme.palette.grey[400],
  textAlign: 'center',
  marginTop: 4,
}));

export default function ProgressArc({ current, total, label }) {
  const percentage = total > 0 ? (current / total) * 100 : 0;

  return (
    <Container>
      <ProgressContainer>
        <CircularProgress
          variant="determinate"
          value={100}
          size={80}
          thickness={4}
          sx={{ color: '#f0f0f0' }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          <CircularProgress
            variant="determinate"
            value={percentage}
            size={80}
            thickness={4}
            sx={{ color: '#79c912' }}
          />
        </Box>
        <TextContainer>
          <ProgressText>{current}/{total}</ProgressText>
        </TextContainer>
      </ProgressContainer>
      {label && <Label>{label}</Label>}
    </Container>
  );
}
